import { useState } from 'react';

import { Circle } from 'lucide-react';

import { db } from './firebase';
import { doc, setDoc } from 'firebase/firestore';

import { auth } from './firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';

const NewPost = () => {
  const [isSignedIn, setIsSignedIn] = useState(false);

  const handleNewPost = async (e) => {
    e.preventDefault();
    const title = e.target['title'].value;
    const shortTitle = e.target['short-title'].value;
    const content = e.target['content'].value;
    const post = {
      title: title,
      shortTitle: shortTitle,
      content: content,
      figmaUrl: e.target['figma-url'].value + "&footer=false&theme=light",
      date: new Date(),
    };
    try {
      const docRef = doc(db, 'projects', shortTitle);
      await setDoc(docRef, post);
    } catch (e) {
      console.error('Error adding document: ', e);
    }
    e.target.reset();
  }

  const handleSignIn = (e) => {
    e.preventDefault();
    const email = e.target.email.value;
    const password = e.target.password.value;
    signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in 
        setIsSignedIn(true);
        e.target.reset();
      })
      .catch((error) => console.log(error));
  }

  return (
    <form className="new-post-form" onSubmit={(e) => isSignedIn ? handleNewPost(e) : handleSignIn(e)}>
      <div className="animated-logo">
        <Circle className="logo-component" size={"1rem"} />
        <Circle className="logo-component" size={"1rem"} />
        <Circle className="logo-component" size={"1rem"} />
      </div>
      {
        isSignedIn ?
          <>
            <div className="form-section">
              <label>Title</label>
              <input
                type="text"
                name="title"
                placeholder="The full title of the post"
              />
            </div>

            <div className="form-section">
              <label>Short Title</label>
              <input
                type="text"
                name="short-title"
                placeholder="Catchy snake case title"
              />
            </div>

            <div className="form-section">
              <label>Figma URL</label>
              <input
                type='text'
                name='figma-url'
                placeholder='https://figma.com/file/1234'
              />
            </div>

            <div className="form-section">
              <label>Content</label>
              <textarea className="content-input" name="content" />
            </div>
          </>
          :
          <>
            <div className="form-section">
              <label>Email</label>
              <input name="email" placeholder="You're not supposed to be here" />
            </div>

            <div className="form-section">
              <label>Password</label>
              <input name="password" type="password" placeholder="Contact me" />
            </div>
          </>
      }

      <button type="submit" className="new-post-button">{isSignedIn ? "Publish" : "Sign In"}</button>
    </form>
  );
}

export default NewPost;